import { post, get, remove, put } from '../Services/http';
import { catchError } from './Error.action';

import {
    OFFERPAGE_RECEIVE,
    OFFERPAGE_SET_LIST,
    FAVOURITES_SET_LISTS
} from '../ConstantsBrafab/constants';

export const setList = (listName) => ({
    type: OFFERPAGE_SET_LIST,
    payload: {
        selectedFavouriteList: listName
    }
})

export const getOfferPage = () => (dispatch) => {
    return get('/api/offer')
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const saveListToUsers = (selectedFavouriteList, personsInSameOrg) => (dispatch) => {
    return post('/api/offer/saveListToUsers', { selectedFavouriteList, personsInSameOrg })
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const deleteList = (listId) => (dispatch) => {
    return remove('/api/offer', { selectedFavouriteList: listId })
        .then(response => response.json())
        .then(offerPage => {
            dispatch(receiveFavouriteLists(offerPage.favouriteLists))
            dispatch(receive(offerPage.offerPage))
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const deleteItem = (favouriteListItemSystemId) => (dispatch, getState) => {
    const state = getState().offerPage;
    return remove('/api/offer/deleteItem', 
    { 
        favouriteListItemSystemId ,
        selectedFavouriteList: state.selectedFavouriteList
    })
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const setCurrency = (currentCurrency) => (dispatch) => {
    return post('/api/offer/setCurrency', currentCurrency )
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const setTerms = () => (dispatch, getState) => {
    const state = getState().offerPage;
    return post('/api/offer/setCustomerListTerms', 
        {
            customerTerms: state.customerTerms, 
            selectedFavouriteList: state.selectedFavouriteList
        })
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
}

export const move = (direction, favouriteListItemSystemId) => (dispatch, getState) => {
    const state = getState().offerPage;
    return put('/api/offer/move', 
        {
            direction, 
            favouriteListItemSystemId,
            selectedFavouriteList: state.selectedFavouriteList
        })
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const updateTerms = (customerTerms) => ({
    type: OFFERPAGE_SET_LIST,
    payload: {
        customerTerms
    }
})

export const setDate = (offerDate) => (dispatch) => {
    return post('/api/offer/setDate', offerDate)
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const setDiscountPercentage = (percentageDiscount, articleNumber) => (dispatch, getState) => {
    const state = getState().offerPage;
    let payload = {}
    if (percentageDiscount){
        payload =  {
            percentageDiscount,
            articleNumber,
            selectedFavouriteList: state.selectedFavouriteList
        }
    }
    else {
        payload =  {
            articleNumber,
            selectedFavouriteList: state.selectedFavouriteList
        }
    }

    return put('/api/offer/setDiscountPercentage', payload)
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const setDiscountPrice = (discountPrice, articleNumber) => (dispatch, getState) => {
    const state = getState().offerPage;
    return put('/api/offer/setDiscountPrice',
     {
        discountPrice,
        articleNumber,
        selectedFavouriteList: state.selectedFavouriteList
    })
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const createOfferGroup = (groupName, items) => (dispatch, getState) => {
    const state = getState().offerPage;
    return post('/api/offer/createOfferGroup', 
    { 
        groupName,
        items,
        selectedFavouriteList: state.selectedFavouriteList
     })
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}


export const setGeneralDiscount = (generalDiscount) => (dispatch, getState) => {
    const state = getState().offerPage;
    let payload = {}

    if (generalDiscount){
        payload =  {
            percentageDiscount: generalDiscount,
            selectedFavouriteList: state.selectedFavouriteList
        }
    }
    else {
        payload =  {
            selectedFavouriteList: state.selectedFavouriteList
        }
    }
    return put('/api/offer/setGeneralDiscount', payload)
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const setItemAmount = (itemAmount, favouriteListItemSystemId) => (dispatch, getState) => {
    const state = getState().offerPage;
    return put('/api/offer/setItemAmount', 
    { 
        itemAmount,
        favouriteListItemSystemId,
        selectedFavouriteList: state.selectedFavouriteList
     })
        .then(response => response.json())
        .then(offerPage => dispatch(receive(offerPage)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}

export const receive = offerPage => (
    {
        type: OFFERPAGE_RECEIVE,
        payload: offerPage,
    })

export const submitError = error => ({
    type: FAVOURITES_SUBMIT_ERROR,
    payload: {
        error,
    },
})

export const receiveFavouriteLists = (favouriteLists) => {
    return {
        type: FAVOURITES_SET_LISTS,
        payload: {
            favouriteLists,
        },
    };
};